/**
 * snappy.trade (the apex) serves the marketing landing section of this same
 * build: nginx proxies it to the app.snappy.trade upstream and rewrites
 * `/` → `/landing`, `/x` → `/landing/x`. The upstream returns one SPA shell for
 * every path and the router reads the browser url, so the FE must mirror that
 * mapping: on a landing host the landing routes mount at `/` and the terminal
 * is reached through the app origin instead of the in-app `/` route.
 */
export const APP_ORIGIN = 'https://app.snappy.trade';

const LANDING_HOSTS = new Set(['snappy.trade', 'www.snappy.trade']);

export function isLandingHost(
    hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): boolean {
    return LANDING_HOSTS.has(hostname);
}

/** Where "open the terminal" links go: in-app `/`, or the app origin on the apex. */
export function terminalHref(hostname?: string): string {
    return isLandingHost(hostname) ? `${APP_ORIGIN}/` : '/';
}
